import { Separator } from "@shared/components/ui/separator";

const HeadLayout = ({ children, title }) => {
  return (
    <>
      <div className="flex flex-col md:flex-row items-center justify-between py-5 gap-4 w-full">
        <h2 className="text-xl font-extrabold lg:text-5xl text-foreground">{title}</h2>
        <div className="flex gap-2 items-center">{children}</div>
      </div>
      <Separator />
    </>
  );
};

export default HeadLayout;
